module.exports = __webpack_public_path__ + "img/MITH.65e26f49.svg";